import { PhoneFormatter } from "~app/features/virkeskop/utils/phone-formatter";
import { ISearchVirkesleverantor } from "../../models/virkesleverantorModel";

export class VirkesleverantorListViewModel {

    telefonnummer: string;
    adress: string;

    constructor(private readonly model: ISearchVirkesleverantor) {
        this.telefonnummer = PhoneFormatter.renderPhonePresentation([
            model.mobil,
            model.telefon
        ]);
        this.adress = this.buildString([
            model.adress,
            model.adress2,
            model.postnummer,
            model.postort
        ]);
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get orgnr() {
        return this.model.orgnr;
    }

    get limeId() {
        return this.model.limeId;
    }

    get epost() {
        return this.model.epost != null ? this.model.epost : "";
    }

    get klassning() {
        return this.model.klassning;
    }

    get leverantorsstatus() {
        return this.model.limeId ? "Leverantör" : "Anbudsleverantör";
    }

    get ansvarigVirkeskopare() {
        return this.model.ansvarigVirkeskopare;
    }

    private buildString(values: string[]): string {
        const arr = [];
        values.forEach((v: any) => {
            if (this.notEmpty(v)) {
                arr.push(v);
            }
        });
        return this.combineString(arr);
    }

    private combineString(stringArr: string[]) {
        return stringArr != null ? stringArr.map(p => p).join(", ") : "";
    }

    private notEmpty(value: any) {
        return value !== null && value !== undefined && value !== "";
    }
}
